import {StatsCountShimmer} from './StatsCountShimmer';

export default StatsCountShimmer;